import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { numStr, parseNum } from "@/lib/format";
import { Button, Card, Chip, Field, Input, Loading, Page, PageHeader, StickyFooter } from "@/components/kit";

export default function CmvTarget() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["settings"], queryFn: () => api("/settings") });
  const [f, setF] = useState({ cmv_target: "", price_alert_pct: "", divergence_pct: "" });
  useEffect(() => { if (data) setF({ cmv_target: numStr(data.cmv_target), price_alert_pct: numStr(data.price_alert_pct), divergence_pct: numStr(data.divergence_pct) }); }, [data]);
  const save = useMutation({
    mutationFn: () => api("/settings", { method: "PUT", body: { cmv_target: parseNum(f.cmv_target), price_alert_pct: parseNum(f.price_alert_pct), divergence_pct: parseNum(f.divergence_pct) } }),
    onSuccess: () => { ["settings", "summary", "conference", "conferences", "price-alerts"].forEach((k) => qc.invalidateQueries({ queryKey: [k] })); toast.success("Metas e alertas atualizados"); },
    onError: (e) => toast.error(e.message),
  });
  if (isLoading) return <Loading />;
  return (
    <Page narrow>
      <PageHeader title="Metas e alertas" back />
      <div className="flex flex-col gap-4">
        <Card className="flex flex-col gap-4">
          <div className="flex gap-3"><Flag size={18} style={{ color: "var(--brand)" }} className="shrink-0 mt-0.5" /><p className="text-sm">Quando o CMV % de uma semana passar da meta, o app mostra um alerta no Painel, na lista e dentro da conferência.</p></div>
          <Field label="Meta de CMV (%)"><Input inputMode="decimal" placeholder="30" value={f.cmv_target} onChange={(e) => setF({ ...f, cmv_target: e.target.value })} data-testid="cmv-target-input" /></Field>
          <div className="flex flex-col gap-2"><span className="caption">Sugestões</span><div className="flex gap-2">{[25, 28, 30, 35].map((v) => <Chip key={v} active={parseNum(f.cmv_target) === v} onClick={() => setF({ ...f, cmv_target: String(v) })} data-testid={`cmv-target-suggestion-${v}`}>{v}%</Chip>)}</div></div>
        </Card>
        <Card data-testid="price-alert-settings">
          <Field label="Alerta de preço: aumento acima de (%)" hint="Ao lançar itens de uma nota, avisa quando o preço unitário passar a média das últimas 5 notas do produto por mais que este percentual.">
            <Input inputMode="decimal" placeholder="10" value={f.price_alert_pct} onChange={(e) => setF({ ...f, price_alert_pct: e.target.value })} data-testid="price-alert-pct-input" />
          </Field>
        </Card>
        <Card data-testid="divergence-settings">
          <Field label="Divergência de contagem: variação acima de (%)" hint="Avisa quando a contagem final de um produto fugir mais que este percentual da média das 4 conferências anteriores.">
            <Input inputMode="decimal" placeholder="50" value={f.divergence_pct} onChange={(e) => setF({ ...f, divergence_pct: e.target.value })} data-testid="divergence-pct-input" />
          </Field>
        </Card>
      </div>
      <StickyFooter><Button loading={save.isPending} onClick={() => save.mutate()} data-testid="save-cmv-target-button">Salvar</Button></StickyFooter>
    </Page>
  );
}
